// extracted by mini-css-extract-plugin
export default {"SubTitle":"MainPage_SubTitle__bLMdX"};